module.exports = __webpack_public_path__ + "img/矢量智能对象(1).b473a44b.png";